'use strict';

function initScrollShrink(masthead) {
    const update = () => {
        masthead.classList.toggle('is-scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', update, { passive: true });
    update(); // correct state on load (e.g. browser scroll-position restore)
}

export function init() {
    const btn = document.querySelector('.masthead__hamburger');
    const nav = document.getElementById('navMain');
    const masthead = document.querySelector('.masthead');

    if (masthead) initScrollShrink(masthead);

    if (!btn || !nav) return;

    btn.addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = nav.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(isOpen));
    });

    // Close when clicking outside
    document.addEventListener('click', (e) => {
        if (!nav.classList.contains('is-open')) return;
        if (!nav.contains(e.target) && !btn.contains(e.target)) {
            nav.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
        }
    });

    // Close on Escape
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && nav.classList.contains('is-open')) {
            nav.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
            btn.focus();
        }
    });
}
